import script from "./wc_img.vue?vue&type=script&setup=true&name=wc_img&lang=js"
export * from "./wc_img.vue?vue&type=script&setup=true&name=wc_img&lang=js"

import "./wc_img.vue?vue&type=style&index=0&id=89cea3c4&scoped=true&lang=css"

import exportComponent from "E:\\SYH-SPMS\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89cea3c4"]])

export default __exports__